import * as Types from '../types/Customer';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    all: [],
    errors: [],
    masterData: {},
    // item: new HotelRequest().update(),
    item: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
    teamPoints: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.CUSTOMER_TEAM_POINT_LIST_ACTION:
        case Types.CUSTOMER_LIST_ACTION:
            return {...state, isFetching: true};
        case Types.CUSTOMER_LIST_SUCCESS:
            return {...state, isFetching: false, data: action.customers};
        case Types.CUSTOMER_KILL_SESSION_ACTION:
            return {...state, isFetching: true};
        case Types.CUSTOMER_KILL_SESSION_SUCCESS:
            return {...state, isFetching: false};
        case Types.CUSTOMER_TEAM_POINT_LIST_SUCCESS:
            return {...state, isFetching: false, teamPoints: action.teamPoints};
        case Types.CUSTOMER_CREATE_ACTION:
            return {...state, isFetching: true};
        case Types.CUSTOMER_CREATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.CUSTOMER_UPDATE_ACTION:
            return {...state, isFetching: true};
        case Types.CUSTOMER_UPDATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.CUSTOMER_MASTER_DATA_ACTION:
            return {...state, isFetching: true};
        case Types.CUSTOMER_MASTER_DATA_SUCCESS:
            return {...state, isFetching: false, masterData: action.masterData};
        case Types.CUSTOMER_GET_TEM_ACTION:
            return {...state, isFetching: true};
        case Types.CUSTOMER_GET_TEM_SUCCESS:
            return {...state, isFetching: false, item: action.item};
        case Types.CUSTOMER_FAILED:
            return {...state, isFetching: false, errors: action.errors};
        case Types.CUSTOMER_INIT:
            return initialState;
        default:
            return state;
    }
}
